/**
 * Generates language selector data based on provided locales and the current locale.
 *
 * @param {Array} locales - An array of locale objects.
 * @param {string} currentLocale - The current locale.
 * @returns {Object} The language selector data containing items and an optional menu object.
 */
export const getLanSelector = (locales, currentLocale) => {
  const items = locales.map((item) => {
    return {
      key: item.locale,
      value: item.locale,
      label: item.languageDisplayName,
    };
  });

  let menu;
  if (items.length > 1) {
    menu = {id: 'language-selector'};
    locales.some((item) => {
      if (item.locale === currentLocale) {
        menu.label = item.languageDisplayName;

        return true;
      }

      return false;
    });
  }

  return {items, menu};
};
